import { BestOffer } from '@bowtie-web/common';

// Signed in and in the rollout. Both compared to `true`, so an unresolved
// Statsig gate reads as off rather than as a truthy object.
export const getShouldUseBestOffer = (
  isAuthenticated?: boolean,
  isRolloutEnabled?: boolean,
): boolean => isRolloutEnabled === true && isAuthenticated === true;

// Read once, when CouponForm mounts; the field owns the value after that.
export const getInitialCouponCode = (
  shouldUseBestOffer: boolean,
  bestOffer: BestOffer | undefined,
  defaultCouponCode: string,
  carriedOfferCode?: string,
): string => {
  const bestOfferCode = shouldUseBestOffer ? bestOffer?.code : undefined;
  const couponCode = carriedOfferCode || bestOfferCode || defaultCouponCode;
  return couponCode.toUpperCase();
};
